@if (showPen && !lukittu) {
  <app-icon-button (click)="toggleEdit()" actionId="Avasi dialogin: Veroilmoitus > Avaa muokkaa kynä" [dynamicClass]="{ 'edit-pen-active': editing }" additionalClass="edit-pen">
    <span class="fa fa-pencil"></span>
  </app-icon-button>
}

@if (editing && !lukittu) {
  <div class="tili-num">
    <span class="tili-num1">{{ numero1 }}</span>
    <br class="tili-num-break" />
    <span class="tili-num2">{{ numero2 }}</span>
  </div>
  <div class="long-col">
    <span style="line-height: 21px; vertical-align: middle; display: inline-block">{{ label }}</span>
    @if (help) {
      <span [title]="help" class="ion-ios-help-circle-outline" style="margin-left: 15px; color: darkgray"></span>
    }
  </div>
  @if (onkoNumeerinen) {
    <input [formField]="numerot.arvo1" type="text" (blur)="onBlur1()" (input)="onChange1()" decimalNumberField [showAllDecimals]="true" [numberOfDecimals]="desimaaleja" class="short-col input currency col1" autocomplete="kirjanasdfpitoaineistoarkki" data-lpignore="true" />
  }
  @if (!onkoNumeerinen) {
    <input [formField]="tekstit.arvo1" type="text" (blur)="onBlur1()" (input)="onChange1()" class="short-col input col1" autocomplete="kirjanpitoaineistoarkkasdfi" data-lpignore="true" />
  }
  <div style="width: 10px"></div>
  @if (onkoNumeerinen) {
    <input [formField]="numerot.arvo2" type="text" (blur)="onBlur2()" (input)="onChange2()" decimalNumberField [showAllDecimals]="true" [numberOfDecimals]="desimaaleja" class="short-col input currency col2" autocomplete="kirjanasdfpitoaineistoarkki" data-lpignore="true" />
  }
  @if (!onkoNumeerinen) {
    <input [formField]="tekstit.arvo2" type="text" (blur)="onBlur2()" (input)="onChange2()" class="short-col input col2" autocomplete="kirjanpitoaineistoarkkasdfi" data-lpignore="true" />
  }
  <div class="end-marking" [class.save-icons-right]="!onkoNumeerinen">
    {{ end }}
    @if (header1) {
      <span class="col-header col-header1" [class.currency]="onkoNumeerinen">{{ header1 }}</span>
    }
    @if (header2) {
      <span class="col-header col-header2" [class.currency]="onkoNumeerinen">{{ header2 }}</span>
    }
    @if (saving1) {
      <span class="saving saving1" [@slowInQuickOut]="'in'">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </span>
    }
    @if (saveSuccess1) {
      <span class="save-success-text save-success-text1" [@quickInSlowOut]="'in'"> Summa tallennettiin </span>
    }
    @if (saveSuccess1) {
      <mat-icon class="save-success-icon save-success-icon1" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle', 'margin-bottom': '6px' }">done</mat-icon>
    }
    <!-- <span *ngIf="saveFailure1" class="save-failure-text1">
  Tallentamisen aikana tapahtui virhe. Ole hyvä ja yritä uudelleen.
</span> -->
    @if (saveFailure1) {
      <mat-icon class="save-failure-icon save-failure-icon1" [ngStyle]="{ color: 'rgb(255, 72, 102)', 'vertical-align': 'middle' }">error_outline</mat-icon>
    }
    @if (saving2) {
      <span class="saving" [@slowInQuickOut]="'in'">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </span>
    }
    @if (saveSuccess2) {
      <span class="save-success-text" [@quickInSlowOut]="'in'"> Summa tallennettiin </span>
    }
    @if (saveSuccess2) {
      <mat-icon class="save-success-icon" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle', 'margin-bottom': '6px' }">done</mat-icon>
    }
    @if (saveFailure2 || saveFailure1) {
      <span class="save-failure-text"> Tallentamisen aikana tapahtui virhe. Ole hyvä ja yritä uudelleen. </span>
    }
    @if (saveFailure2) {
      <mat-icon class="save-failure-icon" [ngStyle]="{ color: 'rgb(255, 72, 102)', 'vertical-align': 'middle' }">error_outline</mat-icon>
    }
  </div>
  @if (naytaEhdotus) {
    <div style="flex-basis: 100%" class="ehdotusnappula-container">
      <app-primary-button (click)="ehdotus()" actionId="Veroilmoitus: hae ehdotus"> Hae ehdotus </app-primary-button>
    </div>
  }
  @if (kenttaVirhe) {
    <div class="kentta-virhe-container">
      @for (virheViesti of kentanVirheViestit; track virheViesti) {
        <div class="kentta-virhe-rivi">
          <mat-icon class="kentta-virhe-ikoni">error_outline</mat-icon>
          <span>{{ virheViesti }}</span>
        </div>
      }
    </div>
  }
} @else {
  <div class="tili-num">
    <span class="tili-num1">{{ numero1 }}</span>
    <br class="tili-num-break" />
    <span class="tili-num2">{{ numero2 }}</span>
  </div>
  <div class="long-col">{{ label }}</div>
  <div app-veroilmoitus-value-read-only [numero]="numero1" [veroilmoitus]="veroilmoitus" [repeatingMetadata]="repeatingMetadata" [format]="format" [desimaaleja]="desimaaleja" [log]="log" class="short-col" [class.hide-col]="hideCol1" [class.currency]="onkoNumeerinen"></div>
  <div style="width: 10px"></div>
  <div app-veroilmoitus-value-read-only [numero]="numero2" [veroilmoitus]="veroilmoitus" [repeatingMetadata]="repeatingMetadata" [format]="format" [desimaaleja]="desimaaleja" [log]="log" class="short-col" [class.hide-col]="hideCol2" [class.currency]="onkoNumeerinen"></div>
  <div class="end-marking">
    {{ end }}
    @if (header1) {
      <span class="col-header col-header1" [class.currency]="onkoNumeerinen">{{ header1 }}</span>
    }
    @if (header2) {
      <span class="col-header col-header2" [class.currency]="onkoNumeerinen">{{ header2 }}</span>
    }
  </div>
}
